<template>
	<CRow>
		<CCol sm="12">
			<CButton @click="collapse=!collapse" color="primary" class="mb-2">
				فیلتر داده‌ها
			</CButton>
			<CCollapse :show="collapse" :duration="400">
				<CCard>
					<CCardHeader>
						<strong>گزینه‌های فیلتر</strong>
					</CCardHeader>
					<CCardBody>
						<CRow>
                            <CCol sm="3">
								<CInput v-model="form.name.val" :description="form.name.inv" label="نام" />
							</CCol>
							<CCol sm="3">
								<CInput v-model="form.from_number.val" size="sm" dir="ltr" disabled />
								<CButton @click="modal=true" size="sm" color="info" block>انتخاب شماره</CButton>
							</CCol>
							<CCol sm="3">
								<label>کاربر</label>
								<model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
								</model-select>
								<small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
							</CCol>
							<CCol sm="3">
								<CSelect
									v-model="form.is_active.val"
									:description="form.is_active.inv"
									label="وضعیت"
									:options="[
										{value: 'true', label:'فعال'},
										{value: 'false', label:'غیرفعال'},
									]"
									placeholder="انتخاب کنید"
									@change="form.is_active.val=$event.target.value"
								/>
							</CCol>
						</CRow>
						<CRow>
							<CCol sm="3">
								<CSelect
									v-model="form.is_send.val"
									:description="form.is_send.inv"
									label="ارسال شده"
									:options="[
										{value: 'true', label:'بله'},
										{value: 'false', label:'خیر'},
									]"
									placeholder="انتخاب کنید"
									@change="form.is_send.val=$event.target.value"
								/>
							</CCol>
							<CCol sm="3">
								<CSelect
									v-model="form.is_finished.val"
									:description="form.is_finished.inv"
									label="پایان یافته"
									:options="[
										{value: 'true', label:'بله'},
										{value: 'false', label:'خیر'},
									]"
									placeholder="انتخاب کنید"
									@change="form.is_finished.val=$event.target.value"
								/>
							</CCol>
							<CCol sm="3">
								<label>تاریخ ایجاد</label>
								<date-picker placeholder="انتخاب کنید" v-model="form.created_at.val"></date-picker>
							</CCol>
							<CCol sm="3">
								<label>آخرین ارسال</label>
								<date-picker placeholder="انتخاب کنید" v-model="form.last_send.val"></date-picker>
							</CCol>
						</CRow>
						<br>
						<div class="form-group form-actions">
							<CButton @click="validator();filter=true;page=1;get()" class="ml" color="primary">فیلتر</CButton>
							<CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
						</div>
					</CCardBody>
				</CCard>
			</CCollapse>
		</CCol>
		<CCol col="12" xl="12">
			<CCard>
				<CCardHeader>
					<strong>پیام‌های تدریجی</strong> 
					<div class="card-header-actions">
						تعداد: {{row_count}}
					</div>
				</CCardHeader>
				<CCardBody>
					<CCol sm="5">
						<CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
						{value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count"
						placeholder="تعداد سطرها" @change="limit=$event.target.value" />
					</CCol>
					<CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
						<template #is_active="data">
                            <td v-if="data.item.is_active">
                                <CIcon name="cilCheckAlt" size="lg"/>
                            </td>
                            <td v-else>
                                <CIcon name="cilX" size="lg"/>
                            </td>
                        </template>
                        <template #is_send="data">
                            <td v-if="data.item.is_send">
                                <CIcon name="cilCheckAlt" size="lg"/>
                            </td>
                            <td v-else>
                                <CIcon name="cilX" size="lg"/>
                            </td>
                        </template>
                        <template #is_finished="data">
                            <td v-if="data.item.is_finished">
                                <CIcon name="cilCheckAlt" size="lg"/>
                            </td>
                            <td v-else>
                                <CIcon name="cilX" size="lg"/>
                            </td>
                        </template>
                        <template #action="data">
                            <td>
                                <template>
                                    <div class="flex-container">
										<div v-show="$store.state.perms.can_add_out_box_gradual_sms_rcv_numbers
                                            || $store.state.perms.can_add_out_box_gradual_sms_rcv_numbers_for_same_group_users
                                            || $store.state.perms.can_add_out_box_gradual_sms_rcv_numbers_for_all_users"
                                            @click="redirect_to(`/gradual/message/${data.item.id}/receiver/add`)"
                                            v-c-tooltip.hover="'افزودن گیرنده‌ها'">
                                            <CIcon name="cilPlaylistAdd" size="lg"/>
                                        </div>
										<div v-show="$store.state.perms.can_view_out_box_gradual_sms_rcv_number_page"
                                            @click="redirect_to(`/gradual/messages/${data.item.id}/receivers`)"
                                            v-c-tooltip.hover="'گیرنده‌ها'">
                                            <CIcon name="cilListRich" size="lg"/>
                                        </div>
										<div v-show="$store.state.perms.can_add_out_box_gradual_sms_send_sequences
                                            || $store.state.perms.can_add_out_box_gradual_sms_send_sequences_for_same_group_users
                                            || $store.state.perms.can_add_out_box_gradual_sms_send_sequences_for_all_users"
                                            @click="redirect_to(`/gradual/message/${data.item.id}/sequence/add`)"
                                            v-c-tooltip.hover="'افزودن روند'">
                                            <CIcon name="cilPlaylistAdd" size="lg"/>
                                        </div>
										<div v-show="$store.state.perms.can_view_out_box_gradual_sms_send_sequence_page"
                                            @click="redirect_to(`/gradual/messages/${data.item.id}/sequences`)"
                                            v-c-tooltip.hover="'روند‌ها'">
                                            <CIcon name="cilListRich" size="lg"/>
                                        </div>
                                        <div v-show="$store.state.perms.can_update_out_box_gradual_sms_group
                                            || $store.state.perms.can_update_out_box_gradual_sms_group_for_same_group_users
                                            || $store.state.perms.can_update_out_box_gradual_sms_group_for_all_users"
                                            @click="redirect_to(`/gradual/message/${data.item.id}/edit`)"
                                            v-c-tooltip.hover="'ویرایش'">
                                            <CIcon name="cilPencil" size="lg"/>
                                        </div>
                                        <div v-show="$store.state.perms.can_delete_out_box_gradual_sms_group
                                            || $store.state.perms.can_delete_out_box_gradual_sms_group_for_same_group_users
                                            || $store.state.perms.can_delete_out_box_gradual_sms_group_for_all_users"
                                            @click="delete_modal=true;id=data.item.id"
                                            v-c-tooltip.hover="'حذف'">
                                            <CIcon name="cilTrash" size="lg"/>
                                        </div>
                                    </div>
                                </template>
                            </td>
                        </template>
          		</CDataTable>
				<br>
				<div> 
					<CPagination
					:activePage.sync="page"
					:pages="page_count"
					align="center"
					:doubleArrows="true"
					/>
				</div>
			</CCardBody>
		</CCard>
		</CCol>
		<CModal
			title="دقت کنید"
			size="sm"
			color="danger"
			:show.sync="delete_modal"
			>
			<p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
			<template #footer>
				<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
				<CButton @click="delete_row" color="danger">بله</CButton>
			</template>
		</CModal>
		<CModal
            title="انتخاب شماره"
            size="sm"
            color="info"
            :show.sync="modal"
            >
            <CRow>
                <CCol sm="12">
                    <CInput v-model="number_like" @keyup.enter="get_numbers()" dir="ltr" label="جستجو در شماره‌ها"/>
                    <small>راهنما: برای جستجو در شماره‌ها چند رقم از شماره مورد نظر را وارد کرده و سپس دکمه Enter را فشار دهید. پس از نمایش پیغام پایان جستجو، شماره مورد نظر را از زیر انتخاب کنید.</small>
                </CCol>
                <CCol sm="12">
                    <br/>
                    <label>انتخاب شماره</label>
                    <model-select :options="numbers" v-model="from_selected" placeholder="انتخاب کنید">
                    </model-select>
                    <small class="form-text text-muted w-100">{{form.from_number.inv}}</small>
                </CCol>
            </CRow>
            <template #footer>
                <CButton @click="form.from_number.val=from_selected;modal=false;" color="primary">تایید</CButton>
                <CButton @click="modal=false" color="secondary">بستن</CButton>
            </template>
        </CModal>
  </CRow>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
	data() {
		return {
			row_count: '',
			items: [],
			fields: [
				{ key: 'id', label: 'شناسه' },
                { key: 'name', label: 'نام' },
                { key: 'sms_text', label: 'متن پیام' },
                { key: 'from_number', label: 'از شماره' },
                { key: 'user_name', label: 'نام کاربر' },
                { key: 'is_active', label: 'وضعیت' },
                { key: 'is_send', label: 'شروع ارسال' },
                { key: 'is_finished', label: 'پایان ارسال' },
                { key: 'created_at', label: 'تاریخ ایجاد' },
                { key: 'last_send', label: 'تاریخ آخرین ارسال' },
				{ key: 'max_receiver_count', label: 'حداکثر تعداد گیرنده' },
				{ key: 'send_count', label: 'تعداد ارسال' },
                { key: 'action', label: 'عملیات' },
			],
			collapse: false,
			form: {
				name: {val: '', inv: '', v: {max: 1024}},
				from_number: {val: '', inv: '', v: {max: 1024}},
				user_id: {val: '', inv: '', v: {max: 8}},
				is_active: {val: '', inv: '', v: {max: 8}},
				is_send: {val: '', inv: '', v: {max: 8}},
				is_finished: {val: '', inv: '', v: {max: 8}},
				created_at: {val: '', inv: '', v: {max: 16}},
				last_send: {val: '', inv: '', v: {max: 16}},
			},
			disable: false,
			page: 1,
			page_count: 0,
			offset: 0,
			limit: 10,
			delete_modal: false,
            id: 0,
			users:[],
			modal: false,
            number_like: '',
            numbers: [],
            from_selected: '',
		}
	},
	watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        }
    },
	mounted() {
		this.get();
		this.get_users();
	},
	methods: {
		get_numbers() {
            this.axios.get('user_nums/'
                + '?number_like=' + this.number_like)
                .then(res => {
                    res.data.map(val => {
                        this.numbers.push({ value: `${val.number}`, text: `${val.number}`});
                    });
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        text: 'جستجوی شماره‌ها با موفقیت انجام شد.'
                    });
                })
        },
		get() {
			if(this.disable == false){
				let filter = '';
				for (const key in this.form) {
					if(this.form[key].val != ''){
						filter += `&${key}=` + this.form[key].val;
					}
				}
				this.axios.get('out_box_gradual_sms_groups/'
					+ '?count=1'
					+ filter)
					.then(res => {
						this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
						this.offset = 0;
						if(this.page != 1){
							this.offset = (this.page * this.limit) - this.limit;
						}
					})
				.finally(() => {
					this.axios.get('out_box_gradual_sms_groups/'
						+ '?limit=' + this.limit
						+ '&offset=' + this.offset
						+ '&user_info=1'
						+ filter)
						.then(res => {
							res.data.map(val =>{
								val.user_name = `${val.user_info.first_name} ${val.user_info.last_name}`;
								val.created_at = this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
								if(val.last_send == '0001-01-01T00:00:00Z'){
									val.last_send = '---';
								} else {
									val.last_send = this.$moment(val.last_send, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
								}
							});
							this.items = res.data;
						})
				})
			}
		},
		delete_row() {
			this.axios.delete('out_box_gradual_sms_groups/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
				});
				this.delete_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
				});
				this.delete_modal = false;
			})
		},
		remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
		redirect_to(route) {
			this.$router.push(route);
		},
		get_users(){
            this.axios.get('users/?type=view_out_box_gradual_sms_groups')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
	},
	beforeCreate(){
		if(this.$store.state.perms.can_view_out_box_gradual_sms_page == false
			&& this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>